<template>
  <div class="container">
    <h2>Next, let's verify your income</h2>
    <p style="text-align: center;">
      We use don’t share your personal information without your permission, and
      we don’t sell or rent it to outside companies.
    </p>
    <div class="company-logo-container">
      <img style="height: 38px;" src="@/assets/plaid_logo.png" />
      <img class="plus-logo" src="@/assets/plus.svg" />
      <div class="rentapp-logo">
        <img src="@/assets/logo.png" />
        <h5>
          Rent Application
        </h5>
      </div>
    </div>
    <div class="info">
      <div class="description" style="">
        <p>Designed with your safety in mind</p>
        <p class="paragraph">
          Your data is powerful—and no one should access it without your
          permission. For that reason, our security practices are designed to
          meet or exceed industry standards.
        </p>
      </div>
      <div class="dividing-line-container">
        <div class="vertical-line"></div>
      </div>

      <div class="feature-set-list-container">
        <div class="feature-set-list">
          <div class="check-item">
            <img src="@/assets/check.svg" />
            <p>
              Data Encryption
            </p>
          </div>
          <div class="check-item">
            <img src="@/assets/check.svg" />
            <p>
              Strong Authentication
            </p>
          </div>
          <div class="check-item">
            <img src="@/assets/check.svg" />
            <p>
              Cloud Infrastructure
            </p>
          </div>
          <div class="check-item">
            <img src="@/assets/check.svg" />
            <p>
              Robust Monitoring
            </p>
          </div>
          <div class="check-item">
            <img src="@/assets/check.svg" />
            <p>
              Strong Authentication
            </p>
          </div>
          <a href="#">Find out more</a>
        </div>
      </div>
    </div>
    <template v-if="!isApplicantLoading">
      <div class="actions">
        <a class="link" @click="linkBankAccount"
          >Verify Income <img src="@/assets/arrow.svg"
        /></a>
        <a class="skip" @click="openSkipModal()">Skip</a>
      </div>
    </template>
    <template v-else>
      Loading...
    </template>
    <skip-modal skip-type="income" @skip="skipIncomeVerification" />
  </div>
</template>
<script>
import { APPLICANT_VERIFICATION_ADD_INCOME } from "@/store/types";
const plaidEnv = process.env.VUE_APP_PLAID_ENV;
const plaidKey = process.env.VUE_APP_PLAID_PUBLIC_KEY;

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      handler: null,
      plaidEvents: []
    };
  },
  computed: {
    ...mapGetters(["isApplicantLoading", "getApplicantVerification"])
  },
  mounted() {
    if (!window.Plaid) {
      const plaidScript = document.createElement("script");
      plaidScript.src =
        "https://cdn.plaid.com/link/v2/stable/link-initialize.js";

      document.getElementsByTagName("head")[0].appendChild(plaidScript);
    }
  },
  methods: {
    openSkipModal() {
      this.$modal.show("skip");
    },
    async skipIncomeVerification() {
      try {
        await this.$store.dispatch(APPLICANT_VERIFICATION_ADD_INCOME, {
          income_skipped: true
        });
        this.$router.push({ name: "verify-applicant-complete" });
      } catch (err) {
        console.log(err);
      }
    },
    linkBankAccount() {
      const that = this;
      const handler = window.Plaid.create({
        clientName: "Rentapplication powered by Plaid",
        env: plaidEnv,
        key: plaidKey,
        product: ["assets"],
        onLoad() {
          console.log("Plaid loaded");
        },
        async onSuccess(public_token, metadata) {
          const eventData = {
            event: "SUCCESS",
            verification: that.getApplicantVerification,
            metadata
          };
          that.plaidEvents.push(eventData);

          try {
            await that.$store.dispatch(APPLICANT_VERIFICATION_ADD_INCOME, {
              token: public_token
            });
            that.$router.push({ name: "verify-applicant-complete" });
          } catch (err) {
            console.log(err);
          }
        },
        onEvent(eventName, metadata) {
          const eventData = {
            event: eventName,
            verification: that.getApplicantVerification,
            metadata
          };
          that.plaidEvents.push(eventData);
        },
        onExit() {
          
        }
      });
      handler.open();
    }
  }
};
</script>
<style lang="scss" scoped>
.vertical-line {
  border-left: 1px solid #cfcfd2;
  margin: 20px 0px;
  height: 100%;
}
.container {
  max-width: 700px;
  height: 100vh;
  margin: auto;
  padding: 30px 0px;
  h2 {
    font-size: 45px;
    line-height: 64px;
    font-weight: 400;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 34px;
    color: #545454;
    max-width: none;
  }
  .company-logo-container {
    display: flex;
    justify-content: center;

    .plus-logo {
      height: 24px;
      margin: 8px 20px;
    }
    .rentapp-logo {
      display: flex;
      img {
        width: 38px;
        height: 38px;
      }
      h5 {
        margin: 0px;
        margin-left: 5px;
        font-size: 18px;
        line-height: 34px;
        font-weight: 400;
      }
    }
  }
  .info {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    .description {
      flex: 3;
      .paragraph {
        font-weight: 300;
      }
    }
    .dividing-line-container {
      flex: 1;
      display: flex;
      justify-content: center;
    }
    .feature-set-list-container {
      flex: 3;
      display: flex;
      justify-content: center;

      .feature-set-list {
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .check-item {
          display: flex;
          p {
            margin: 0px;
            margin-left: 5px;
            font-weight: 300;
          }
        }
        a {
          font-size: 18px;
          line-height: 34px;
          color: #545454;
          font-weight: 300;
        }
      }
    }
  }
}
h2 {
  text-align: center;
}

.email_sent {
  margin-top: 50px;
  text-align: center;
}
.actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;

  .link {
    display: block;
    width: 200px;
    padding: 10px 0;
    border: 2px solid #3ec19d;
    background: #3ec19d;
    border-radius: 2px;
    text-decoration: none;
    font-size: 18px;
    color: #fff;
    text-align: center;
    font-weight: 600;
    cursor: pointer;
    font-size: 18px;
    margin: 10px;
    font-weight: 300;

    img {
      position: relative;
      top: 2.5px;
      margin-left: 7px;
    }
  }
  .skip {
    text-decoration: underline;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
  .container {
    padding: 30px 15px;
    h2 {
      margin-top: 0px;
      font-size: 32px;
      line-height: 45px;
      font-weight: 400;
    }
    p {
      font-size: 16px;
      line-height: 25px;
    }
    .info {
      flex-direction: column;
      .dividing-line-container {
        display: none;
      }
      .feature-set-list-container {
        .feature-set-list {
          a {
            font-size: 16px;
          }
        }
      }
    }
    .actions {
      margin-top: 20px;
    }
  }
}
</style>
